import { render, staticRenderFns } from "./SharedPresentLevelsPage.vue?vue&type=template&id=146c053c&scoped=true"
import script from "./SharedPresentLevelsPage.vue?vue&type=script&lang=js"
export * from "./SharedPresentLevelsPage.vue?vue&type=script&lang=js"
import style0 from "./SharedPresentLevelsPage.vue?vue&type=style&index=0&id=146c053c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c053c",
  null
  
)

export default component.exports